/*
 *
 * PayByLinkTutorialPopup
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 27-Mar-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  tutorialPopupTitle: <PortalMessage id='t.app.services.payByLink.popup.tutorial.title' defaultMessage='Come funziona Pay-By-Link?' />,
  tutorialPopupCopyFirstPoint: <PortalMessage id='t.app.services.payByLink.popup.tutorial.copy.first' defaultMessage='Attiva il servizio e potrai incassare anche quando i tuoi clienti non sono in negozio.' />,
  tutorialPopupCopySecondPoint: <PortalMessage id='t.app.services.payByLink.popup.tutorial.copy.second' defaultMessage='Usarlo è semplice e veloce: genera il link di pagamento.' />,
  tutorialPopupCopyThirdPoint: <PortalMessage id='t.app.services.payByLink.popup.tutorial.copy.third' defaultMessage='Condividilo con il cliente che potrà pagare direttamente online.' />,
  tutorialPopupButtonLabel: <PortalMessage id='t.app.continue' defaultMessage='Continua' />
}

export default formattedMessage
